import React, { useState } from 'react';
import { faqs } from '../data/mockData';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const FAQSection = () => {
  const [openIndex, setOpenIndex] = useState(0);

  return (
    <section className="py-24 px-6 bg-white" aria-labelledby="faq-heading">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-16">
          <h2 id="faq-heading" className="text-3xl font-serif text-[#2C2C2C] mb-4">Frequently Asked Questions</h2>
          <p className="text-[#737373]">Everything you need to know about shopping with us.</p>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, index) => {
            const isOpen = openIndex === index;
            return (
              <div 
                key={index} 
                className="border-b border-[#E5E5E5] pb-4"
              >
                <button 
                  className="w-full flex justify-between items-center py-4 text-left group focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#8B7355] rounded-sm px-2 -mx-2"
                  onClick={() => setOpenIndex(isOpen ? -1 : index)}
                  aria-expanded={isOpen}
                  aria-controls={`faq-answer-${index}`}
                >
                  <span className="text-lg font-medium text-[#2C2C2C] group-hover:text-[#8B7355] transition-colors">
                    {faq.question}
                  </span>
                  <span className="text-[#A3A3A3] ml-4 shrink-0 transition-transform duration-300" style={{ transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)' }}>
                    <SafeIcon icon={isOpen ? FiIcons.FiMinus : FiIcons.FiPlus} className="w-5 h-5" />
                  </span>
                </button>
                
                <div 
                  id={`faq-answer-${index}`}
                  role="region"
                  className={`overflow-hidden transition-all duration-300 ease-in-out px-2 ${
                    isOpen ? 'max-h-[200px] opacity-100 mb-4' : 'max-h-0 opacity-0'
                  }`}
                >
                  <p className="text-[#595959] md:pr-12 leading-relaxed">
                    {faq.answer}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default FAQSection;